var homeBannerSetting = function(){
	$('.home-grid-banner').find('.radio-item').each(function(){
		var imageSrc = $(this).find('img').attr('data-src');
		var imageAlt = $(this).find('img').attr('alt');
		$(this).css({
			'background-image' : 'url('+imageSrc+')',
		});
		//$(this).find('img').remove();  
	});
};


var widgetSlider = function(){
	$('.widget-slider').each(function(){

		$(this).on('init', function(event, slick){ 
			var maxHeight = 0; 
			$(this).find(".radio-item").each(function(){   
				if ($(this).find(".title >a").height() > maxHeight){
					maxHeight = $(this).find(".title >a").height(); 
				}
			});
			$(this).find(".radio-item .title >a").height(maxHeight);  
		});

		$(this).slick({
	        dots: false,
			infinite: false,
			speed: 600, 
			slidesToShow: 2,
			slidesToScroll: 1,
			mobileFirst: true,
			touchThreshold: 10,
			swipeToSlide: true,
			responsive: [
			    {
			      	breakpoint: 576,
			      	settings: {
			        	slidesToShow: 3,
			      	}
			    },
			    {
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow: 4,
			      	}
			    },
			    {
			      	breakpoint: 1200,
			      	settings: {
			        	slidesToShow: 5,
			      	}
			    },
			    {
			      	breakpoint: 1600,
			      	settings: {
			        	slidesToShow: 6,
			      	}
			    }
			]
		});
		
	});
};

(function( $ ) {

	homeBannerSetting();

	widgetSlider();

	$('.home-widget').each(function(){
		var $homeWidget = $(this);
		$homeWidget.find('.radio-item').each(function(){
			$(this).find('.dropup').on('show.bs.dropdown', function () {
				$('.home-widget').removeClass('on-focus');
	 			$homeWidget.addClass('on-focus');
			});
		});
	});
   
	$(window).resize(function() {
		$('.widget-slider').each(function(){
			$(this).slick('resize');
		});
	});

}(jQuery));
